import {FC, useState, ReactNode} from 'react'
import classnames from 'classnames'
import {HoverDescription} from 'jbc-front/components/presenters/ui/HoverDescription'
import {ProcedureStatus} from 'types/api/procedureStatuses/procedureStatus'
import styles from './ProceduresListForMember.scss'

// @ts-ignore
import {makeMaternityDatum} from 'procedures/maternityLeave/Form'
// @ts-ignore
import {statuses, procedureTypes} from 'procedureStatuses/List'
// @ts-ignore
import {recordDisplay} from 'utils'

const divisions = {
  single: '単胎',
  multiple: '多胎',
}

type Division = 'single' | 'multiple'

type HoverNoteTrProps = {
  procedureStatus: ProcedureStatus
  handleClick: (value: number) => void
  children: ReactNode
}
type ProceduresListProps = {
  procedureStatuses: ProcedureStatus[]
  handleClick: (value: number) => void
}

const HoverNoteTr: FC<HoverNoteTrProps> = ({procedureStatus, handleClick, children}) => {
  const [isHover, setIsHover] = useState(false)
  const isApplying = procedureStatus.status === 'applying'

  return (
    <>
      <div className={styles.hoverDescriptionContainer}>
        <HoverDescription position="bottom" isHover={isApplying && isHover}>
          産休開始手続きが承認されるまで、変更の手続きは行えません。
          <br />
          管理者による承認完了後に手続きを行ってください。
        </HoverDescription>
      </div>

      <tr
        className={classnames('table-hover', styles.tr)}
        onMouseOver={() => setIsHover(true)}
        onMouseOut={() => setIsHover(false)}
        onClick={isApplying ? undefined : () => handleClick(procedureStatus.id)}
      >
        {children}
      </tr>
    </>
  )
}

export const ProceduresList: FC<ProceduresListProps> = ({procedureStatuses, handleClick}) => {
  return (
    <div>
      <div className="l-overflow-scroll">
        <table className="m-table-list m-table-fixed">
          <thead>
            <tr>
              <th>手続き</th>
              <th>出産予定年月日</th>
              <th>出産種別</th>
              <th>休業開始年月日</th>
              <th>休業終了（予定）年月日</th>
              <th>ステータス</th>
            </tr>
          </thead>
          <tbody>
            {procedureStatuses.map((procedureStatus) => {
              const procedureMaternityDatum = makeMaternityDatum(procedureStatus)

              return (
                <HoverNoteTr key={procedureStatus.id} procedureStatus={procedureStatus} handleClick={handleClick}>
                  <td>{procedureTypes[procedureStatus.procedure_type]}</td>
                  <td>
                    {recordDisplay(
                      procedureMaternityDatum?.expected_birth_date &&
                        procedureMaternityDatum.expected_birth_date.replace(/-/g, '/')
                    )}
                  </td>
                  <td>
                    {recordDisplay(
                      procedureMaternityDatum?.maternity_division &&
                        divisions[procedureMaternityDatum.maternity_division as Division]
                    )}
                  </td>
                  <td>
                    {recordDisplay(
                      procedureMaternityDatum?.started_at && procedureMaternityDatum.started_at.replace(/-/g, '/')
                    )}
                  </td>
                  <td>
                    {recordDisplay(
                      procedureMaternityDatum?.expected_finished_at &&
                        procedureMaternityDatum.expected_finished_at.replace(/-/g, '/')
                    )}
                  </td>
                  <td>{recordDisplay(statuses[procedureStatus.status])}</td>
                </HoverNoteTr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
